import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setNavigate, notifyListeners } from '../const/history';

function NavigationSetter({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const prevLocation = useRef(location);

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    if (prevLocation.current !== location) {
      // Determine action type (PUSH, POP, or REPLACE)
      const action = 'PUSH'; // Default to PUSH for simplicity
      notifyListeners(location, action);
      prevLocation.current = location;
    }
  }, [location]);

  return children;
}

export default NavigationSetter;
